import Badge from './Badge';
import type {FriendData, ProfileSummary} from '../types/steam';
import {getSmurfMatch} from '../utils/dateUtils';

interface FriendListItemProps {
    friend: FriendData;
    mainProfile: ProfileSummary;
}

function FriendListItem({friend, mainProfile}: FriendListItemProps) {
    const smurfMatch = getSmurfMatch(friend, mainProfile);
    
    return (
        <li>
            <a
                href={`/${friend.player.steamid}`}
                className="friend-list-item"
            >
                <div className="min-w-0 flex flex-col">
                    <span className="friend-name block font-medium truncate hover:underline pointer-events-none">
                        {friend.player.personaname}
                    </span>
                    <a
                        href={`https://steamcommunity.com/profiles/${friend.player.steamid}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="friend-id text-xs text-muted hover:underline pointer-events-auto"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {friend.player.steamid}
                    </a>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                    {friend.bans.VACBanned && (
                        <Badge variant="vac">VAC</Badge>
                    )}
                    {friend.bans.NumberOfGameBans > 0 && (
                        <Badge variant="game" title="Game ban present">Game Ban</Badge>
                    )}
                    {smurfMatch?.type === 'direct' && (
                        <Badge variant="smurf" strength={smurfMatch.strength}
                               title="Current name matches or is similar to the viewed profile name">
                            Potential Smurf
                        </Badge>
                    )}
                    {smurfMatch?.type === 'recent' && (
                        <Badge variant="smurf-recent" strength={smurfMatch.strength}
                               title="Current name matches one of the viewed profile's recent names">
                            Recent Name Match
                        </Badge>
                    )}
                </div>
            </a>
        </li>
    );
}

export default FriendListItem;
